// extracted by mini-css-extract-plugin
export default {"header":"HotDeals_header__o1vam","product_img":"HotDeals_product_img__DZa3E"};